module.exports = __webpack_public_path__ + "img/2021_michigan_1.17405c86.jpg";